"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _RootCloseWrapper = _interopRequireDefault(require("react-overlays/lib/RootCloseWrapper"));

var _utils = require("../utils");

var _constants = require("../constants");

/**
 * Higher-order component to encapsulate Token behaviors.
 */
var tokenContainer = function tokenContainer(Component) {
  var WrappedComponent =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inheritsLoose2.default)(WrappedComponent, _React$Component);

    function WrappedComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        active: false
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleBlur", function (e) {
        _this.setState({
          active: false
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleKeyDown", function (e) {
        switch (e.keyCode) {
          case _constants.BACKSPACE:
            if (_this.state.active) {
              // Prevent backspace keypress from triggering the browser "back"
              // action.
              e.preventDefault();

              _this.props.onRemove();
            }

            break;

          default:
            break;
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleActive", function (e) {
        e.stopPropagation();

        _this.setState({
          active: true
        });
      });
      return _this;
    }

    var _proto = WrappedComponent.prototype;

    _proto.render = function render() {
      return _react.default.createElement(_RootCloseWrapper.default, {
        onRootClose: this._handleBlur
      }, _react.default.createElement(Component, (0, _extends2.default)({}, this.props, this.state, {
        onBlur: this._handleBlur,
        onClick: this._handleActive,
        onFocus: this._handleActive,
        onKeyDown: this._handleKeyDown
      })));
    };

    return WrappedComponent;
  }(_react.default.Component);

  (0, _defineProperty2.default)(WrappedComponent, "displayName", "tokenContainer(" + (0, _utils.getDisplayName)(Component) + ")");
  return WrappedComponent;
};

var _default = tokenContainer;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/containers/tokenContainer.js
// module id = 357
// module chunks = 0